// Dependencies
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 40px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 24px;
`

export const NeedHelpIcon = styled.img`
  display: block;
`

export const NeedHelpContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const NeedHelpSectionTitle = styled.h4`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  color: #25272d;
`

export const NeedHelpSectionSubtitle = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: #7c8195;
`

export const NeedHelpButton = styled.button`
  display: flex;
  width: 100%;
  height: 56px;
  padding: 16px 52px;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 100px;
  background-color: #df1d3d;

  @media (min-width: 768px) {
    width: max-content;
  }
`

export const NeedHelpButtonLabel = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 900;
  line-height: 24px;
  text-transform: uppercase;
  white-space: nowrap;
  color: #fff;
`
